// types
import { Link } from "react-router-dom";
import { TSLDRLatout } from "../type";
import LanguageVersionSelector from "cms/utilities/LanguageVersionSelector";
import ILanguageVersionDetail from "cms/interfaces/ILanguageVersionDetail";
import { EViewType } from "cms/enums/EViewType";
import { EContentType } from "cms/enums/EContentType";
import { EView } from "cms/enums/EView";
import ApplicationDocumentSelector from "cms/utilities/ApplicationDocumentSelector";
import IApplicationDocument from "cms/interfaces/IApplicationDocument";
import { EResourceType } from "cms/enums/EResourceType";
import { FaYoutube } from "react-icons/fa";
import { isEmpty } from "lodash";
import SanitizeHTMLString from "cms/utilities/SanitizeHTMLString";
import CoreDefault from "core/Defaults";
import useProgressiveImage from "core/hooks/useProgressiveImage";


function SLDR_001 ( props: Readonly<TSLDRLatout> ) {
    console.log("SLDR_001: ", props);

    const languageVersion = LanguageVersionSelector<ILanguageVersionDetail|null>({
        languageVersions: props.payload.languageVersions,
        filters: [
            { view: EView.OUTTER, viewType: EViewType.NAME_DESCRIPTION, contentType: EContentType.SLIDER_ITEM },
            { view: EView.OUTTER, viewType: EViewType.NAME_DESCRIPTION, contentType: EContentType.DEFAULT }
        ],
        type: "find"
    });

    const followUs = LanguageVersionSelector<ILanguageVersionDetail|null>({
        languageVersions: props.siteSettingPayload.languageVersions,
        filters: [
            { view: EView.OUTTER, viewType: EViewType.NAME_DESCRIPTION, contentType: EContentType.DEFAULT, name: "followUs" },
        ],
        type: "find"
    });

    const facebook = LanguageVersionSelector<ILanguageVersionDetail|null>({
        languageVersions: props.siteSettingPayload.languageVersions,
        filters: [
            { view: EView.OUTTER, viewType: EViewType.NAME_DESCRIPTION, contentType: EContentType.DEFAULT, name: "facebook" },
        ],
        type: "find"
    });

    const instagram = LanguageVersionSelector<ILanguageVersionDetail|null>({
        languageVersions: props.siteSettingPayload.languageVersions,
        filters: [
            { view: EView.OUTTER, viewType: EViewType.NAME_DESCRIPTION, contentType: EContentType.DEFAULT, name: "instagram" },
        ],
        type: "find"
    });

    const linkedin = LanguageVersionSelector<ILanguageVersionDetail|null>({
        languageVersions: props.siteSettingPayload.languageVersions,
        filters: [
            { view: EView.OUTTER, viewType: EViewType.NAME_DESCRIPTION, contentType: EContentType.DEFAULT, name: "linkedin" },
        ],
        type: "find"
    });

    const youtube = LanguageVersionSelector<ILanguageVersionDetail|null>({
        languageVersions: props.siteSettingPayload.languageVersions,
        filters: [
            { view: EView.OUTTER, viewType: EViewType.NAME_DESCRIPTION, contentType: EContentType.DEFAULT, name: "youtube" },
        ],
        type: "find"
    });

    const patternImage = ApplicationDocumentSelector<IApplicationDocument|null>({
        resources: props.payload.resources,
        resourceType: EResourceType.PATTERN,
        type: "find"
    });

    const loaded = useProgressiveImage({ src:patternImage?.filePath ? `${CoreDefault.cdn}/${patternImage?.filePath}` : null });

    return (
        <div className="swiper-slide">
            <div className="main-slider-three__social-box">
                <div className="main-slider-three__social-title-box">
                    <h5 className="main-slider-three__social-title">{followUs?.value}</h5>
                    <div className="main-slider-three__social-shape"></div>
                </div>
                <div className="main-slider-three__social">
                    { facebook?.name && <Link to={facebook?.value||"#"}><i className="icon-facebook"></i></Link> }
                    { instagram?.name && <Link to={instagram?.value||"#"}><i className="icon-instagram"></i></Link> }
                    { linkedin?.name && <Link to={linkedin?.value||"#"}><i className="icon-link-in"></i></Link> }
                    { youtube?.name && <Link to={youtube?.value||"#"}><FaYoutube /></Link> }
                </div>
            </div>
            <div 
                className="main-slider-three__bg"
                style={loaded?{backgroundImage: `url('${loaded}')`, backgroundPosition: "center", backgroundRepeat: "no-repeat", backgroundSize: "cover"}:undefined}
            />
            <div className="container">
                <div className="row">
                    <div className="col-xl-12">
                        <div className="main-slider-three__content">
                            <h2 className="main-slider-three__title">{languageVersion?.name}</h2>
                            {
                                !isEmpty(languageVersion?.value) ? (
                                    <p className="main-slider-three__text ck-content" dangerouslySetInnerHTML={{ __html: SanitizeHTMLString(languageVersion?.value)}} />
                                ) : (
                                    <p className="main-slider-three__text tw-h-8" />
                                )
                            }
                            <div className="main-slider-three__btn-boxes">
                                <div className="main-slider-three__btn-box-1 tw-h-12">
                                    {/* <Link to="about" className="main-slider-three__btn-1 thm-btn">Read more<span className="icon-dabble-arrow-right"></span></Link> */}
                                </div>
                                <div className="main-slider-three__btn-box-2 tw-h-12">
                                    {/* <Link to="contact" className="main-slider-three__btn-2 thm-btn">Contact Us<span className="icon-dabble-arrow-right"></span></Link> */}
                                </div>
                            </div>
                            
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}


export default SLDR_001;
